import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useLanguage } from '../../contexts/LanguageContext';
import { TEAM_IMAGE_PORTRAIT, TEAM_IMAGE_WIDE } from '../../data/links';
import { Reveal } from '../ui/Reveal';
export function Team() {
  const {
    t
  } = useLanguage();
  const ref = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const scale = useTransform(scrollYProgress, [0, 1], [1.12, 1]);
  return <section ref={ref} id="equipo" className="relative flex min-h-[88vh] items-end overflow-hidden bg-ink" data-id="element-240" data-mp="32gwcsca395i7">
      <motion.div style={{
      scale
    }} className="absolute inset-0" data-id="element-241" data-mp="2xgifnpa0zfyy">
        <picture className="block h-full w-full" data-id="element-242" data-mp="2skt8p0voewsm">
          <source media="(max-width: 767px)" srcSet={TEAM_IMAGE_PORTRAIT} data-id="element-243" data-mp="2ohwwbrwqbwx4" />
          <img src={TEAM_IMAGE_WIDE} alt={t.team.imageAlt} className="h-full w-full object-cover" data-id="element-244" data-mp="2ojzl68m5bk09" />
        </picture>
      </motion.div>
      <div className="absolute inset-0 bg-black/55" aria-hidden="true" data-id="element-245" data-mp="a27iz4kdofiy" />

      <div className="relative mx-auto w-full max-w-6xl px-5 pb-20 pt-40 md:px-6 md:pb-28" data-id="element-246" data-mp="eviq76t3qybe">
        <Reveal data-id="element-247" data-mp="13vi89pss1cs">
          <h2 className="max-w-3xl text-5xl font-semibold leading-[1.02] tracking-[-0.035em] text-white md:text-7xl" data-id="element-248" data-mp="14dkpo31zbt5">
            {t.team.title}
          </h2>
        </Reveal>
        <Reveal delay={0.08} data-id="element-249" data-mp="su09msbz5oni">
          <p className="mt-6 max-w-2xl text-lg leading-snug text-white/80 md:text-2xl" data-id="element-250" data-mp="survhbfrs80l">
            {t.team.roles}
          </p>
        </Reveal>
        <Reveal delay={0.14} data-id="element-251" data-mp="jtk65iv8ehin">
          <p className="mt-3 text-lg font-medium text-cyan md:text-2xl" data-id="element-252" data-mp="jsikylki4en7">
            {t.team.anywhere}
          </p>
        </Reveal>
      </div>
    </section>;
}